import { Bounds, Environment, OrbitControls, RoundedBox } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import { DirectionalLight } from 'three/src/lights/DirectionalLight';
import Area from './Area';

function Box(props: React.ComponentProps<typeof RoundedBox> & { color: string }) {
  const { color, ...rest } = props;
  return (
    <RoundedBox {...rest}>
      <meshPhongMaterial color={color} />
    </RoundedBox>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;
  const refLight = React.useRef<DirectionalLight>(null);
  // const [count, setCount] = React.useState(0);
  // React.useEffect(() => {
  //   setCount((prev) => prev + 1);
  // }, []);
  console.log('App01', { refLight });
  return (
    <Area>
      <Canvas camera={{ position: [0, 3, 10], fov: 50 }}>
        <ambientLight />
        {/* <directionalLight ref={refLight} position={[1, 2, 1.5]} intensity={0.5} /> */}
        {/* {refLight.current && <directionalLightHelper light={refLight.current} color="red" />} */}
        {/* <hemisphereLight intensity={1.5} groundColor={'red'} /> */}
        {/* <color attach="background" args={['#000']} />
      <ambientLight intensity={0.5} />
      <pointLight position={[10, 10, 10]} />
      <mesh>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color="orange" />
      </mesh>
      <mesh position={[2, 0, 0]}>
        <sphereGeometry args={[0.5, 32, 32]} />
        <meshStandardMaterial color="blue" />
      </mesh> */}
        {/* <Bounds fit clip observe> */}
        <Box color="#EAC435" args={[1, 5, 1]} rotation-y={Math.PI / 4} position={[0, 0, -2]} />
        <Box color="#03CEA4" args={[2, 2, 2]} position={[-2, 0, -2]} />
        <Box color="#FB4D3D" args={[2, 2, 2]} position={[2, 0, -2]} />
        {/* </Bounds> */}
        {/* <Environment preset="city" /> */}
        <OrbitControls makeDefault autoRotate position={[0, 10, 10]} />
        <axesHelper />
        <gridHelper />
      </Canvas>
    </Area>
  );
}

export default React.memo(App01);
